import React from 'react';
import ExamSubjects from './ExamSubjects';

export default function ExamQuestionbankSubject() {
  return <ExamSubjects categoryId={2} />;
}
